var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 8",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.83004 0.961726L6.91071 7.61865C7.02686 7.73536 7.18137 7.78482 7.33307 7.77704C7.48533 7.78482 7.6393 7.73536 7.75544 7.61865L13.8366 0.961727C14.0545 0.743339 14.0545 0.388786 13.8366 0.170376C13.6188 -0.0480552 13.2653 -0.0480338 13.0475 0.170376L7.33302 6.42667L1.61917 0.170375C1.40132 -0.0480348 1.04788 -0.0480348 0.83004 0.170375C0.612197 0.388741 0.612197 0.743316 0.83004 0.961726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.920d5839a4edf7c7f9df50e95fc0459a.svg";
export { ForwardRef as ReactComponent };